/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Ob_Proof_UniversitiesInputs */

const en_funnel_ob_proof_universities = /** @type {(inputs: Funnel_Ob_Proof_UniversitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`universities`)
};

const es_funnel_ob_proof_universities = /** @type {(inputs: Funnel_Ob_Proof_UniversitiesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`universidades`)
};

/**
* | output |
* | --- |
* | "universities" |
*
* @param {Funnel_Ob_Proof_UniversitiesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_ob_proof_universities = /** @type {((inputs?: Funnel_Ob_Proof_UniversitiesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Ob_Proof_UniversitiesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_ob_proof_universities(inputs)
	return en_funnel_ob_proof_universities(inputs)
});